import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

type SuporteModal = {
  hospital: boolean,
  criarHospital: boolean,
  editarHospital: boolean,
  visualizarGrupo: boolean,
}

type SetSuporteModal = {
  name: string,
  value: boolean,
}

interface NovoHospital {
  grupoHospitalId: string;
  nome: string;
  cnpj: string;
  codigoHis: string;
  ultimaSituacaoFluxoNF: string;
  fazConciliacao: boolean;
  integracaoAtiva: boolean;
  geraAgrupamento: boolean;
  appExibeProducao: boolean;
  appExibeProducaoProfissionalExecutante: boolean;
  appExibeConciliacao: boolean;
  appLiberaGestaoProducao: boolean;
  appExibeCalculadora: boolean;
  backOfficePodeAlterarPrestador: boolean;
  backOfficePodeExcluirRepasse: boolean;
  cargaRegraResponsavelRepasse: string;
  fazCargaRepasseArquivo: boolean;
  cargaRepasseArquivoModoAgrupamento: string;
  exibirOpcaoRelatorioAssinaturaDiretoria: boolean;
  integracaoApiKey: string;
  liberaUsuarioGestor: boolean;
  liberaUsuarioProfissionalExecutante: boolean;
  calculoAtivo: boolean;
  cargaRepasseVerificaDuplicidadePorNumero: boolean;
  backOfficePodeIncluirItemRepasse: boolean;
  backOfficePodeExcluirItemRepasse: boolean;
  calculoModoDisparo: string;
  grupoRepassePadraoHonorarioMedicoId: string;
  notaFiscalModoUpload: string;
  naoSolicitarNFPrestadorPF: boolean;
  calcularPorContratoComRegra: boolean;
  podeProvisionarRepasse: boolean;
  regraRepassePadraoHisId: string;
  logo: string;
  cargaRepasseStatusInicial: string;
}

type Mode = 'CREATE' | ''

@Module({ namespaced: true, name: 'SuporteHospitaisRemuneracaoStore' })
export default class SuporteHospitaisRemuneracaoStore extends VuexModule {
  private novoHospitalDefault: NovoHospital = {
    grupoHospitalId: '',
    nome: '',
    cnpj: '',
    codigoHis: '',
    ultimaSituacaoFluxoNF: '',
    fazConciliacao: false,
    integracaoAtiva: false,
    geraAgrupamento: false,
    appExibeProducao: false,
    appExibeProducaoProfissionalExecutante: false,
    appExibeConciliacao: false,
    appLiberaGestaoProducao: false,
    appExibeCalculadora: false,
    backOfficePodeAlterarPrestador: false,
    backOfficePodeExcluirRepasse: false,
    cargaRegraResponsavelRepasse: '',
    fazCargaRepasseArquivo: false,
    cargaRepasseArquivoModoAgrupamento: '',
    exibirOpcaoRelatorioAssinaturaDiretoria: false,
    integracaoApiKey: '',
    liberaUsuarioGestor: false,
    liberaUsuarioProfissionalExecutante: false,
    calculoAtivo: false,
    cargaRepasseVerificaDuplicidadePorNumero: false,
    backOfficePodeIncluirItemRepasse: false,
    backOfficePodeExcluirItemRepasse: false,
    calculoModoDisparo: '',
    grupoRepassePadraoHonorarioMedicoId: '',
    notaFiscalModoUpload: '',
    naoSolicitarNFPrestadorPF: false,
    calcularPorContratoComRegra: false,
    podeProvisionarRepasse: false,
    regraRepassePadraoHisId: '',
    logo: '',
    cargaRepasseStatusInicial: '',
  }

  public grupoHospital: any[] = []
  public hospitais: any[] = []
  public grupoRepasses: any[] = []
  public modoUploadItems: any[] = []
  public tiposCarga: any[] = []
  public calculoModoDisparo: any[] = []
  public cargaRegraResponsavelRepasse: any[] = []
  public cargaRepasseArquivoModoAgrupamento: any[] = []
  public tiposCargaSelected: any[] = []
  public calculoModoDisparoSelected: string = ''
  public grupoHospitalDetails: any = {}
  public hospitalDetails: any = {}
  public showCadastroHospitais: boolean = false
  public hospitalId: string = ''
  public mode: Mode = ''
  public novoHospital: NovoHospital = { ...this.novoHospitalDefault }

  public modal: SuporteModal = {
    hospital: false,
    criarHospital: false,
    editarHospital: false,
    visualizarGrupo: false,
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  clearNovoHospital() {
    this.novoHospital = { ...this.novoHospitalDefault }
  }

  @Mutation
  setNovoHospital() {
    this.novoHospital = { ...this.hospitalDetails }
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  setShowCadastroHospitais(value: boolean) {
    this.showCadastroHospitais = value
  }

  @Mutation
  setGrupoHospital(values: any[]) {
    this.grupoHospital = values
  }

  @Mutation
  setHospitais(values: any[]) {
    this.hospitais = values
  }

  @Mutation
  setGrupoRepasses(values: any[]) {
    this.grupoRepasses = values
  }

  @Mutation
  setModoUploadItems(values: any[]) {
    this.modoUploadItems = values
  }

  @Mutation
  setGrupoHospitalDetails(values: any) {
    this.grupoHospitalDetails = values
  }

  @Mutation
  setHospitalDetails(values: any) {
    this.hospitalDetails = values
  }

  @Mutation
  clearHospitalDetails() {
    this.hospitalDetails = {}
  }

  @Mutation
  setTiposCarga(values: any[]) {
    this.tiposCarga = values
  }

  @Mutation
  setCalculoModoDisparo(values: any[]) {
    this.calculoModoDisparo = values
  }

  @Mutation
  setCargaRegraResponsavelRepasse(values: any[]) {
    this.cargaRegraResponsavelRepasse = values
  }

  @Mutation
  setCargaRepasseArquivoModoAgrupamento(values: any[]) {
    this.cargaRepasseArquivoModoAgrupamento = values
  }

  @Mutation
  setTiposCargaSelected(values: any[]) {
    this.tiposCargaSelected = values
  }

  @Mutation
  setCalculoModoDisparoSelected(value: string) {
    this.calculoModoDisparoSelected = value
  }

  @Mutation
  setListaDeHospitais(values: any[]) {
    this.hospitais = values
  }

  @Mutation
  clearHospitaisDetails() {
    this.tiposCargaSelected = []
    this.calculoModoDisparoSelected = ''
    this.grupoHospitalDetails = {}
  }

  @Action
  async getGrupoHospital() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllGrupoHospital()
    if (response.success) {
      this.context.commit('setGrupoHospital', response.data.itens)
    }
    return response
  }

  @Action
  async getHospitaisPorGrupo(id: string) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHospitaisPorGrupo(id)
    if (response.success) {
      this.context.commit('setHospitalId', id)
      this.context.commit('setHospitais', response.data)
    }
    return response
  }

  @Action
  async getGrupoRepasses() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllGrupoRepasses()
    if (response.success) {
      this.context.commit('setGrupoRepasses', response.data)
    }
    return response
  }

  @Action
  async getModoUploadItems() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getModoUploadItems()
    if (response.success) {
      this.context.commit('setModoUploadItems', response.data)
    }
    return response
  }

  @Action
  async getTiposDeCarga() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllTipoCarga()
    if (response.success) {
      this.context.commit('setTiposCarga', response.data)
    }
    return response
  }

  @Action
  async getCalculoModoDisparo() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllTipoDisparo()
    if (response.success) {
      this.context.commit('setCalculoModoDisparo', response.data)
    }
    return response
  }

  @Action
  async getCargaRegraResponsavelRepasse() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllCargaRegraResponsavelRepasse()
    if (response.success) {
      this.context.commit('setCargaRegraResponsavelRepasse', response.data)
    }
    return response
  }

  @Action
  async getCargaRepasseArquivoModoAgrupamento() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllCargaRepasseArquivoModoAgrupamento()
    if (response.success) {
      this.context.commit('setCargaRepasseArquivoModoAgrupamento', response.data)
    }
    return response
  }

  @Action
  async getGrupoHospitalById(id: string) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllGrupoHospitalById(id)
    if (response.success) this.context.commit('setGrupoHospitalDetails', response.data)
    return response
  }

  @Action
  async getHospitalById(id: string) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHospitalById(id)
    if (response.success) this.context.commit('setHospitalDetails', response.data)
    return response
  }

  @Action
  async getListaDeHospitais() {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllHospital()
      if (request.success) this.context.commit('setListaDeHospitais', request.data.map((hospital: any) => ({ id: hospital.id, nome: hospital.nome })))
      return request
    } catch (error) {
      this.context.commit('setListaDeHospitais', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async updateGrupoHospital() {
    const dataToUpdate = { ...this.grupoHospitalDetails }

    delete dataToUpdate.createdOn
    delete dataToUpdate.transacaoFinanceiraId
    delete dataToUpdate.transacaoFinanceiraNome
    dataToUpdate.calculoAtivo = !!dataToUpdate.calculoAtivo
    dataToUpdate.cargaRepasseCriarGeracaoRepasse = !!dataToUpdate.cargaRepasseCriarGeracaoRepasse
    dataToUpdate.integracaoRepasseEnviarAlugueis = !!dataToUpdate.integracaoRepasseEnviarAlugueis
    dataToUpdate.id = dataToUpdate.id

    if (!this.tiposCargaSelected || this.tiposCargaSelected.length === 0) {
      dataToUpdate.tiposDeCarga = this.grupoHospitalDetails.tiposDeCarga.map(carga => carga.key)
    } else {
      dataToUpdate.tiposDeCarga = this.tiposCargaSelected
    }

    if (!this.calculoModoDisparoSelected) {
      dataToUpdate.calculoModoDisparo = this.grupoHospitalDetails.calculoModoDisparo.key
    } else {
      dataToUpdate.calculoModoDisparo = this.calculoModoDisparoSelected
    }

    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateGrupoHospital(dataToUpdate)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async createGrupoHospital() {
    const dataToCreate = { ...this.grupoHospitalDetails }

    dataToCreate.tiposDeCarga = this.tiposCargaSelected
    dataToCreate.calculoModoDisparo = this.calculoModoDisparoSelected
    dataToCreate.calculoAtivo = !!dataToCreate.calculoAtivo
    dataToCreate.possuiCalculoGestor = !!dataToCreate.possuiCalculoGestor
    dataToCreate.logo = dataToCreate.logo || '0'
    dataToCreate.cargaRepasseCriarGeracaoRepasse = !!dataToCreate.cargaRepasseCriarGeracaoRepasse
    dataToCreate.integracaoRepasseEnviarAlugueis = !!dataToCreate.integracaoRepasseEnviarAlugueis

    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createGrupoHospital(dataToCreate)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async criarHospital() {
    try {
      const params: any = { ...this.novoHospital }
      params.grupoHospitalId = this.hospitalId
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createHospital(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async atualizarHospital() {
    try {
      const params: any = { ...this.hospitalDetails }
      delete params.integracaoAluguelAgrupamento
      params.grupoHospitalId = this.hospitalId
      params.id = this.hospitalDetails.id

      // Função para verificar se o campo key esta presente no objeto
      const ajustarCamposComKey = (obj: any, campos: string[]) => {
        campos.forEach((campo) => {
          if (obj[campo] && typeof obj[campo] === 'object' && 'key' in obj[campo]) {
            obj[campo] = obj[campo].key
          } else if (!obj[campo]) {
            obj[campo] = null
          }
        })
      }

      // Campos que tem o key
      const camposParaVerificar = [
        'cargaRepasseStatusInicial',
        'grupoRepassePadraoHonorarioMedicoId',
        'calculoModoDisparo',
        'cargaRegraResponsavelRepasse',
        'notaFiscalModoUpload',
        'cargaRepasseArquivoModoAgrupamento',
        'ultimaSituacaoFluxoNF',
      ]

      ajustarCamposComKey(params, camposParaVerificar)

      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateHospital(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
